export default __webpack_public_path__ + "static/media/sakkare_holige.ad515de9.png";